import { Link } from "react-router-dom";
import { categories } from "@/mocks/mangaData";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg" />
              </span>
              <span className="font-heading text-lg text-foreground-950">
                日漫<span className="text-primary-600">情报站</span>
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              日漫最新话、日漫连载、日漫更新、日漫情报、日漫剧透、日漫休刊提醒，让你第一时间掌握追更动态，不再错过任何一话。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">追更分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.id}`} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">快速导航</h3>
            <ul className="mt-4 space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">关于我们</Link></li>
              <li><Link to="/about#contact" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">联系与订阅</h3>
            <p className="mt-4 text-sm text-foreground-600">订阅我们的资讯快报，第一时间获取日漫最新话与连载情报。</p>
            <Link
              to="/about#contact"
              className="mt-4 inline-flex whitespace-nowrap items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-send-line text-base" />
              订阅资讯
            </Link>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-sm text-foreground-600">
            © 2026 日漫情报站 · 所有内容仅供参考，尊重原作版权。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 transition-colors hover:text-primary-600" aria-label="微博">
              <i className="ri-weibo-line text-lg" />
            </a>
            <a href="#" className="text-foreground-500 transition-colors hover:text-primary-600" aria-label="哔哩哔哩">
              <i className="ri-bilibili-line text-lg" />
            </a>
            <a href="#" className="text-foreground-500 transition-colors hover:text-primary-600" aria-label="公众号">
              <i className="ri-wechat-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}